import { render, staticRenderFns } from "./vc-form-control.vue?vue&type=template&id=518d6b4c&scoped=true&"
import script from "./vc-form-control.vue?vue&type=script&lang=js&"
export * from "./vc-form-control.vue?vue&type=script&lang=js&"
import style0 from "./vc-form-control.vue?vue&type=style&index=0&id=518d6b4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d6b4c",
  null
  
)

export default component.exports